import { Region, RegionCode } from '~/types'

export const Regions: Record<Region, { code: RegionCode; name: string }> = {
    Barbados: { code: 'bb', name: 'Barbados' },
    Jamaica: { code: 'jm', name: 'Jamaica' },
    Turks: { code: 'tc', name: 'Turks & Caicos' },
}

// Server-side only function
export const getAllowedRegion = (): RegionCode | null => {
    if (typeof process === 'undefined') return null
    const allowedRegion = process.env.ALLOWED_REGION as RegionCode
    return allowedRegion || null
}

// Client-safe function that accepts allowed region as parameter
export const isSingleRegionMode = (allowedRegion?: RegionCode | null | undefined): boolean => {
    if (allowedRegion === undefined) {
        // Not loaded yet, don't restrict
        return false
    }
    if (allowedRegion !== undefined) {
        return allowedRegion !== null
    }
    return getAllowedRegion() !== null
}
